import { render, staticRenderFns } from "./VerticalLabel.vue?vue&type=template&id=cf54ac8c&scoped=true"
import script from "./VerticalLabel.vue?vue&type=script&lang=ts"
export * from "./VerticalLabel.vue?vue&type=script&lang=ts"
import style0 from "./VerticalLabel.vue?vue&type=style&index=0&id=cf54ac8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf54ac8c",
  null
  
)

export default component.exports